export const ConverterParaISO = (date: Date, timeHHmm: string) => {
  const [hh, mm] = (timeHHmm || "00:00").split(":").map(Number);
  const d = new Date(date);
  d.setHours(hh, mm, 0, 0);
  const yyyy = d.getFullYear();
  const MM = String(d.getMonth() + 1).padStart(2, "0");
  const DD = String(d.getDate()).padStart(2, "0");
  const HH = String(d.getHours()).padStart(2, "0");
  const MI = String(d.getMinutes()).padStart(2, "0");
  return `${yyyy}-${MM}-${DD}T${HH}:${MI}:00`;
};
